var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2011 8V11.1108C11.2011 11.4444 11.2209 11.7752 11.2605 12.1033C11.3001 12.4315 11.3523 12.7659 11.4171 13.1067H12.5506C12.6154 12.7659 12.6675 12.4315 12.7071 12.1033C12.7467 11.7752 12.7665 11.4444 12.7665 11.1108V8H11.2011ZM12.95 15.07C12.95 14.9395 12.9257 14.818 12.8771 14.7056C12.8286 14.5932 12.762 14.4954 12.6774 14.412C12.5929 14.3286 12.493 14.2624 12.3779 14.2135C12.2627 14.1645 12.1368 14.14 12 14.14C11.8669 14.14 11.7427 14.1645 11.6276 14.2135C11.5124 14.2624 11.4117 14.3286 11.3253 14.412C11.2389 14.4954 11.1715 14.5932 11.1229 14.7056C11.0743 14.818 11.05 14.9395 11.05 15.07C11.05 15.2005 11.0743 15.3229 11.1229 15.4371C11.1715 15.5513 11.2389 15.6501 11.3253 15.7335C11.4117 15.8169 11.5124 15.8822 11.6276 15.9293C11.7427 15.9764 11.8669 16 12 16C12.1368 16 12.2627 15.9764 12.3779 15.9293C12.493 15.8822 12.5929 15.8169 12.6774 15.7335C12.762 15.6501 12.8286 15.5513 12.8771 15.4371C12.9257 15.3229 12.95 15.2005 12.95 15.07Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.1848e95a.svg";
export { ForwardRef as ReactComponent };